import { createAsyncThunk } from '@reduxjs/toolkit';
import { userLoggedOut } from '~/slices/userSlice';
import { authApiUrl } from '~/constants';
import { updateSingleThunk } from './updateThunks';
import { convertToMySqlDateFormat } from '~/utils/utils';

export const signOutThunk = createAsyncThunk(
  'auth/signOut',
  async ({ navigate, reason }: { navigate: (path: string) => void, reason?: string }, { dispatch, rejectWithValue, getState }) => {
    try {
      const state = getState() as any;
        const createdLoginId = state.user.createdLoginId;
        console.log(`Sign out successful. Reason: ${reason || 'No reason provided'}. Created Login ID: ${createdLoginId}`);
        console.log("User signed out successfully");
        await dispatch(updateSingleThunk({
                  dataType: 'logins',
                  data: {
                    id: createdLoginId,
                    logout_time: convertToMySqlDateFormat(new Date()),
                    disconnection_reason: reason || 'User initiated sign out',
                  },
                }));
      const response = await fetch(authApiUrl + "signout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        }
      });

      if (response.ok) {
        
        dispatch(userLoggedOut());
        setTimeout(() => {
            navigate("/");
        }, 300);
        return { success: true };
      } else {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue(errorData.message || 'Sign out failed');
      }
    } catch (error) {
      console.error("Sign out error:", error);
      return rejectWithValue(error instanceof Error ? error.message : 'Network error during sign out');
    }
  }
);